import { render, staticRenderFns } from "./SongDetail.vue?vue&type=template&id=15e5e97a&scoped=true"
import script from "./SongDetail.vue?vue&type=script&lang=ts"
export * from "./SongDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e5e97a",
  null
  
)

export default component.exports